export const updatePageSEO = (data: {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogTitle?: string;
  ogDescription?: string;
  structuredData?: object;
}) => {
  // Update title
  document.title = data.title;

  // Update or create meta tags
  const updateMetaTag = (name: string, content: string, isProperty = false) => {
    const attribute = isProperty ? 'property' : 'name';
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  };

  updateMetaTag('description', data.description);
  updateMetaTag('keywords', data.keywords);
  updateMetaTag('og:title', data.ogTitle || data.title, true);
  updateMetaTag('og:description', data.ogDescription || data.description, true);
  updateMetaTag('og:url', data.canonical, true);
  updateMetaTag('twitter:title', data.ogTitle || data.title);
  updateMetaTag('twitter:description', data.ogDescription || data.description);

  // Update canonical link
  let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = data.canonical;

  // Update structured data
  if (data.structuredData) {
    // Remove existing structured data for this page
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"][data-page-schema]');
    existingScripts.forEach(script => script.remove());

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-page-schema', 'true');
    script.textContent = JSON.stringify(data.structuredData);
    document.head.appendChild(script);
  }
};
